import React from "react";
import StyleUtils from "../../utils/StyleUtils";
import { buildGoogleFontsURL } from "../../utils/FontUtils";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { generateFontsTagsFromDesignContext } from "../../utils/FontUtils";
import { isEmpty } from "lodash";

class ThemeCSSGenerator {
  generate(themeImm, layout, designContext) {
    const theme = themeImm.toJS(); //convert to standard JS
    let css = "";
    let tags = [];

    if (!isEmpty(theme)) {
      const fonts = Object.values(theme.fonts);
      tags.push(...generateFontsTagsFromDesignContext(fonts, designContext));

      css += StyleUtils.getThemeCSS(themeImm, layout);
    }

    return {
      css: css,
      tags: tags,
    };
  }
}

export default new ThemeCSSGenerator();
